import type { Placement } from '@popperjs/core';

interface PartialProp {
  isOpen?: boolean | null;
}
interface PartialState {
  isOpen: boolean;
}

export const isOpenCheck = (props: PartialProp, state: PartialState): boolean => {
  const isOpenStateControllerViaProp = props.isOpen !== undefined;
  return !!(isOpenStateControllerViaProp ? props.isOpen : state.isOpen);
};

export const getAnimationPosition = (placement: Placement = 'auto') => {
  const distance = '10px';
  const direction: Record<string, string> = {
    auto: `0px,0px,0px`,
    top: `0px,${distance},0px`,
    right: `-${distance},0px,0px`,
    bottom: `0px,-${distance},0px`,
    left: `${distance},0px,0px`,
  };
  // -start & -end direction use the same coordinates as base direction
  const finalPlacement = placement.replace('-start', '').replace('-end', '');
  return direction[finalPlacement];
};
